<template>
  <div class="page_box">
    <div class="page_option_box">
      <div class="option_box">
        <el-button type="primary" size="small" plain @click="exportData"
          >导出</el-button
        >
        <el-radio-group v-model="statisticsTime" size="small" style="margin-left:10px">
          <el-radio-button
            :value="value.id"
            :label="value.id"
            v-for="value in $store.state.select.statisticsTimeList"
            :key="value.id"
            >{{ value.name }}</el-radio-button
          >
        </el-radio-group>
      </div>
      <div class="search_box">
        <el-date-picker
          v-if="statisticsTime == 0"
          class="select-date"
          size="small"
          :picker-options="pickerOptions"
          v-model="selectYear"
          value-format="timestamp"
          type="year"
          placeholder="选择年"
          :clearable="false"
        >
        </el-date-picker>
        <el-select
          v-if="statisticsTime == 1"
          class="select-date"
          v-model="selectQuarter"
          size="small"
          placeholder="请选择"
        >
          <el-option
            v-for="(item, key) in quarterInitialization"
            :disabled="item.disable"
            :key="key"
            :label="item.dateName"
            :value="item.dateNumber"
          >
          </el-option>
        </el-select>
        <el-date-picker
          v-if="statisticsTime == 2"
          class="select-date"
          size="small"
          :picker-options="pickerOptions"
          value-format="timestamp"
          v-model="selectMonth"
          type="month"
          placeholder="选择月"
          :clearable="false"
        >
        </el-date-picker>
        <el-date-picker
          v-if="statisticsTime == 3"
          class="select-date"
          v-model="selectWeek"
          size="small"
          type="week"
          format="yyyy 第 WW 周"
          :picker-options="pickerOptions"
          placeholder="选择周"
          :clearable="false"
        >
        </el-date-picker>
        <el-select
          class="select-date"
          v-model="requestData.dailyTaskId"
          @change="selectTask"
          size="small"
          clearable
          placeholder="请选择巡查任务"
        >
          <el-option
            v-for="(item, index) in allTask"
            :key="index"
            :label="item.dailyTaskName"
            :value="item.dailyTaskId"
          >
          </el-option>
        </el-select>
        <el-cascader
          class="select-date"
          :options="departmentHead"
          v-model="testUserInfo.userId"
          @change="selectDepartmentHead"
          ref="departmentHeadSelect"
          size="small"
          filterable
          clearable
          placeholder="请选择巡查人"
        >
          <template slot-scope="{ node, data }">
            <span>{{ data.label }}</span>
            <span v-if="!node.isLeaf"> ({{ data.children.length }}) </span>
          </template>
        </el-cascader>
      </div>
    </div>
    <div class="inside_pages_right">
      <div class="data-info">
        <div class="info-content">
          <div class="statistics_row_one">
            <div class="statistics-item">
              <div class="duty_item">
                <img
                  class="duty_item_img"
                  src="@/assets/img/statistics/patrol-num.png"
                  alt=""
                />
                <div class="duty_item_text">
                  <div class="duty_item_num">
                    {{ responseData.patrolTotalNum }}
                  </div>
                  <div class="duty_item_tips">巡查总数</div>
                </div>
              </div>
              <div class="duty_item">
                <img
                  class="duty_item_img"
                  src="@/assets/img/statistics/patrolled.png"
                  alt=""
                />
                <div class="duty_item_text">
                  <div class="duty_item_num">
                    {{ responseData.patroled }}
                  </div>
                  <div class="duty_item_tips">已巡查</div>
                </div>
              </div>
              <div class="duty_item">
                <img
                  class="duty_item_img"
                  src="@/assets/img/statistics/unpatrolled.png"
                  alt=""
                />
                <div class="duty_item_text">
                  <div class="duty_item_num">
                    {{ responseData.noPatrol }}
                  </div>
                  <div class="duty_item_tips">未巡查</div>
                </div>
              </div>
              <div class="duty_item">
                <img
                  class="duty_item_img"
                  src="@/assets/img/statistics/patrol-rate.png"
                  alt=""
                />
                <div class="duty_item_text">
                  <div class="duty_item_num">
                    {{ responseData.patroleScale }}%
                  </div>
                  <div class="duty_item_tips">巡查率</div>
                </div>
              </div>
            </div>
          </div>
          <daily-patrol-statistics-chart
            :echartsData="responseData.dataList"
            :title="title"
          ></daily-patrol-statistics-chart>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DailyPatrolStatisticsChart from "./components/DailyPatrolStatisticsChart";
export default {
  name: "",
  components: {
    DailyPatrolStatisticsChart
  },
  props: {},
  data() {
    return {
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        }
      },
      statisticsTime: -1,
      selectYear: "",
      selectQuarter: -1,
      // 部门负责人
      departmentHead: [],

      selectMonth: "",

      selectWeek: "",

      timeList: [],

      // 初始化季度
      quarterInitialization: [],

      requestData: {
        schoolId: this.$store.state.schoolId,
        type: 0,
        startTime: 0,
        endTime: 0,
        userId: "",
        dailyTaskId: ""
      },
      testUserInfo: {
        userId: ""
      },
      responseData: {
        patrolTotalNum: 0,
        patroled: 0,
        noPatrol: 0,
        patroleScale: 0,
        dataList: []
      },
      allTask: [],
      title: "日常巡查统计波段图",
      // 巡查总数列表
      patrolSumList: [],
      // 未巡查数量列表
      notPatrolList: [],
      // 已巡查数量列表
      yesPatrolList: []
    };
  },
  created() {
    this.statisticsTime = 0;
  },
  mounted() {
    this.getDepartmentHead();
    this.getInspectionAllTask();
  },
  watch: {
    statisticsTime() {
      this.requestData.type = this.statisticsTime;
      this.quarterInitialization = this.$Common.createQuarterTwo();
      var times = this.$Common.getPartTimeStamp();
      switch (this.statisticsTime) {
        case 0:
          this.selectYear = times.yearTime;
          this.selectQuarter = -1;
          break;
        case 1:
          this.selectQuarter = times.quarterTime;
          break;
        case 2:
          this.selectQuarter = -1;
          this.selectMonth = times.monthTime;
          break;
        case 3:
          this.selectQuarter = -1;
          this.selectWeek = times.weekTime;
          break;
      }
    },
    // 选择年
    selectYear() {
      if (this.statisticsTime == 0) {
        var resultsObj = this.$Common.getYearTime(this.selectYear);
        this.requestData.startTime = parseInt(resultsObj.startTime / 1000);
        this.requestData.endTime = parseInt(resultsObj.endTime / 1000);
        this.getStatisticalData();
      }
    },
    // 选择季度
    selectQuarter() {
      if (this.statisticsTime == 1) {
        // console.log(111)
        var thisQuarter = this.selectQuarter;
        var resultsObj = this.$Common.getQuarterTime(thisQuarter);
        this.requestData.startTime = parseInt(resultsObj.startTime / 1000);
        this.requestData.endTime = parseInt(resultsObj.endTime / 1000);
        this.getStatisticalData();
      }
    },
    // 选择月
    selectMonth() {
      if (this.statisticsTime == 2) {
        var resultsObj = this.$Common.getMonthTime(this.selectMonth);
        this.requestData.startTime = parseInt(resultsObj.startTime / 1000);
        this.requestData.endTime = parseInt(resultsObj.endTime / 1000);
        this.getStatisticalData();
      }
    },

    // 选择星期
    selectWeek() {
      if (this.statisticsTime == 3) {
        var resultsObj = this.$Common.getWeekTime(this.selectWeek);
        this.requestData.startTime = parseInt(resultsObj.startTime / 1000);
        this.requestData.endTime = parseInt(resultsObj.endTime / 1000);
        this.getStatisticalData();
      }
    }
  },
  computed: {},
  methods: {
    // 获取统计数据
    async getStatisticalData() {
      let newParamData = this.requestData;
      if (Object.is(newParamData.endTime, NaN)) {
        this.$message("请选择时间！");
        return;
      }
      // console.log(newParamData.schoolId)
      // console.log(newParamData.type)
      // console.log(newParamData.startTime+'---------'+this.$Common.dateFormatDateTwo(newParamData.startTime))
      // console.log(newParamData.endTime+'---------'+this.$Common.dateFormatDateTwo(newParamData.endTime))
      let res = await this.$Http.dailyInspectionStatistics(newParamData);
      if (res.code == 200) {
        this.responseData.patrolTotalNum = res.data.patrolInfo.patrolTotalNum;
        this.responseData.patroled = res.data.patrolInfo.patroled;
        this.responseData.noPatrol = res.data.patrolInfo.noPatrol;
        this.responseData.patroleScale = res.data.patrolInfo.patroleScale;
        this.responseData.dataList = res.data.patrolStatistics;
        this.timeList = [];
        this.patrolSumList = [];
        this.notPatrolList = [];
        this.yesPatrolList = [];
        this.responseData.dataList.forEach((element) => {
          this.timeList.push(element.ym);
          this.patrolSumList.push(
            parseInt(element.noPatrol) + parseInt(element.patroled)
          );
          this.notPatrolList.push(element.noPatrol);
          this.yesPatrolList.push(element.patroled);
        });
        // console.log(res.data)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 导出统计记录
    async exportData() {
      let req = this.requestData;
      if (Object.is(req.endTime, NaN)) {
        this.$message("请选择时间！");
        return;
      }
      this.$Common.exportData(req, "exportDailyInspectionStatistics", "日常巡查统计");
    },
    // 选择巡查任务
    selectTask() {
      this.getStatisticalData();
    },
    // 获取学校所有日常巡查任务
    async getInspectionAllTask() {
      let req = {
        schoolId: this.$store.state.schoolId
      };
      let res = await this.$Http.getInspectionAllTask(req);
      if (res.code == 200) {
        // console.log(res.data)
        this.allTask = res.data;
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    },
    // 选择巡查人
    selectDepartmentHead(data) {
      // console.log(this.testUserInfo)
      // console.log(data)
      // console.log(node)
      // var newData = this.$refs.departmentHeadSelect.getCheckedNodes()
      // console.log(newData)
      if (data.length > 0) {
        let value = this.$refs.departmentHeadSelect.panel.getNodeByValue(
          this.testUserInfo.userId
        ).data.thisId;
        // console.log(value)
        // console.log(newData[0].data.thisId);
        this.requestData.userId = value;
      } else {
        this.requestData.userId = "";
      }
      this.getStatisticalData();
      // console.log(this.requestData.userId)
      // this.requestData.userId = newData[0].data.thisId
    },
    // 获取部门及负责人
    async getDepartmentHead() {
      var _this = this;
      var paramData = {
        schoolId: this.requestData.schoolId
      };
      let res = await this.$Http.getDepartmentHead(paramData, true);
      if (res.code == 200) {
        // this.departmentHead = res.data
        _this.selectedPersonList = [];
        var departmentHeadList = [];
        for (var keyOne in res.data) {
          var thisUserList = [];
          for (var keyTwo in res.data[keyOne].dlist) {
            // 负责人默认选择
            if (
              this.requestData.userId == res.data[keyOne].dlist[keyTwo].userId
            ) {
              this.testUserInfo.userId = [];
              this.testUserInfo.userId.push(keyOne);
              this.testUserInfo.userId.push(keyOne + "-" + keyTwo);
            }

            // 巡查人员默认选择
            if (
              this.requestData.dailyTaskTimeStatus == 1 &&
              this.requestData.timeQuantumList.length >= 1
            ) {
              var selectedUserInfo = Object.assign(
                {},
                this.requestData.timeQuantumList[0]
              );
              var selectedUserList = selectedUserInfo.userIdArray
                ? selectedUserInfo.userIdArray.split(",")
                : [];
              selectedUserList.forEach((element) => {
                if (element == res.data[keyOne].dlist[keyTwo].userId) {
                  var personUserGroup = [];
                  personUserGroup.push(keyOne);
                  personUserGroup.push(keyOne + "-" + keyTwo);
                  _this.selectedPersonList.push(personUserGroup);
                }
              });
            } else if (
              this.requestData.dailyTaskTimeStatus == 0 &&
              this.requestData.timeQuantumList.length >= 1
            ) {
              for (var i = 0; this.inspectionPeriod.length > i; i++) {
                var selectedUserList = this.inspectionPeriod[i].userIdArray
                  ? this.inspectionPeriod[i].userIdArray.split(",")
                  : [];
                selectedUserList.forEach((element) => {
                  if (element == res.data[keyOne].dlist[keyTwo].userId) {
                    var personUserGroup = [];
                    personUserGroup.push(keyOne);
                    personUserGroup.push(keyOne + "-" + keyTwo);
                    this.inspectionPeriod[i].userIdString.push(personUserGroup);
                  }
                });
              }
            }

            var newThisData = {
              value: keyOne + "-" + keyTwo,
              label: res.data[keyOne].dlist[keyTwo].userName,
              thisId: res.data[keyOne].dlist[keyTwo].userId,
              thisLevel: 2
            };
            thisUserList.push(newThisData);
          }

          departmentHeadList[keyOne] = {
            value: keyOne,
            label: res.data[keyOne].departmentName,
            thisId: res.data[keyOne].departmentId,
            thisLevel: 1,
            children: thisUserList
          };
        }
        this.departmentHead = departmentHeadList;
        // console.log(this.inspectionPeriod)
      } else if (res.code == 101) {
      } else {
        this.$message({
          type: "error",
          message: res.messsage
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.inside_pages_right {
  height: calc(100% - 70px);
  background: #f5f5f7ff;
  .inside_pages_right_top {
    background: #fff;
  }
  .statistics_top {
    padding: 10px 150px;
    background: #fff;
    .el-radio-group {
      vertical-align: top;
    }
    .select-date {
      display: inline-block;
      width: 158px;
    }
    .year_box,
    .quarter_box,
    .month_box,
    .week_box {
      display: inline-block;
    }
  }

  .data-info {
    margin-top: 8px;
    padding: 30px 150px;
    background: #fff;
    height: calc(100% - 10px);
    .info-content {
      // position: relative;
      background: #ffffff;
      box-shadow: 0px 0px 22px 0px rgba(229, 229, 229, 0.59);
      border-radius: 2px;
      height: 100%;
    }
  }
  .statistics_row_one {
    margin: 0px;
    padding: 40px 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #fff;
    border-bottom: none;
    width: 100%;
    .statistics-item {
      width: 100%;
      max-width: 926px;
      display: flex;
      align-items: center;
      justify-content: space-between;
    }
    .duty_item {
      flex: 1 1 230px;
      display: flex;
      align-items: center;
      flex-direction: column;
      position: relative;
      &:before {
        content: "";
        width: 100%;
        height: 2px;
        background: #eff9ff;
        position: absolute;
        top: 56px;
        left: 0;
        right: 0;
      }
      &:after {
        content: "";
        width: 7px;
        height: 7px;
        background: #c5e6f9;
        border-radius: 50%;
        box-shadow: 0px 1px 4px 0px rgba(64, 107, 132, 0.27);
        position: absolute;
        top: 53.5px;
        left: 50%;
        right: 0;
        margin-left: -3.5px;
      }
    }
    .duty_item_img {
      width: 43px;
      height: 46px;
    }
    .duty_item_text {
      padding-top: 20px;
    }
    .duty_item_num {
      font-size: 20px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #7a7a7a;
      letter-spacing: 1px;
    }
    .duty_item_tips {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #303030;
    }
  }
}
</style>
